export const ACTION_TYPES = {
    SET_FASTLANE: 'SET_FASTLANE',
    SET_PAYMENT_TOKEN: 'SET_PAYMENT_TOKEN',
    SET_CUSTOMER_CONTEXT: 'SET_CUSTOMER_CONTEXT',
    ADD_CANCELED_EMAIL: 'ADD_CANCELED_EMAIL'
}